// Import the necessary modules from Vue and other dependencies
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { createHead } from '@unhead/vue'
import { Icon } from '@iconify/vue'
import { logStyledMessage } from './plugins/crazyLog.js'

import './style.css'
import './assets/index.css'
// @ts-ignore: Ignore module declaration error for router.js
import router from './router.js'

// Import the main App component
import App from './App.vue'
import { isLocalhost } from '@/lib/utils/devUtils.js'

// Import the Iconify plugin directly

import { appConfigs } from '@/appConfigs.js'

// import font css: /assets/fonts/css/general-css.css
import './assets/font/poppins/poppins.css'

logStyledMessage()

const { USE_SENTRY_IN_DEV } = appConfigs

const FORCE_SENTRY = true
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Create a new Vue app instance
const app = createApp(App)

if (USE_SENTRY_IN_DEV || !isLocalhost() || FORCE_SENTRY) {
  Sentry.init({
    app,
    // june 2025
    dsn: 'https://f9fb9ddd0984f567e9c9df89b3cddf72@o4509440706674688.ingest.us.sentry.io/4509457765564416',

    // legacy v1  dsn: 'https://680ce8690aa8d98835257ca0d265d7b5@o4508876310183936.ingest.us.sentry.io/4508876496961536',
    // integrations: [],
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: isLocalhost() ? 'dev 🧪🧑‍💻' : 'production',
  })
}
// myUndefinedFunction();

app.use(pinia)
// Register the Iconify component globally
app.component('Icon', Icon)

const head = createHead()
app.use(head)

// Use the router
app.use(router)

// import 'html-midi-player'

// Mount the app to the DOM element with the id 'app'
app.mount('#app')
